import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { removeOldestQuery } from "@tanstack/react-query-persist-client";
import { compress, decompress } from "lz-string";

// Create a client for react query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 2 * (60 * 1000), // 2 mins
      gcTime: 10 * (60 * 1000), // 10 mins
    },
  },
});

export const persister = createSyncStoragePersister({
  key: "queryClientCache",
  storage: typeof window !== "undefined" ? window.localStorage : undefined,
  serialize: (data) => {
    console.log("serialize", data);
    return compress(JSON.stringify(data));
  },
  deserialize: (data) => {
    console.log("deserialize", data);
    return JSON.parse(decompress(data));
  },
  retry: removeOldestQuery,
});
